module.exports = __webpack_public_path__ + "static/media/a0aba844.jpg";